import * as React from "react"
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import { Action, IOWidget, mk_widget } from "widgets-for-react"
import { CMSState, Url } from "../types.gen"
import { getClassName, getFileType, convertReactNodeToString } from "../utils.gen"
import { blockInviewHandler } from "../../../drupal/rendering/inview_utils.mod";
import { datalayerHandler } from "../utils/gtm.mod"

export type DownloadBlockProps = {
  index: number
  title?: React.ReactNode
  intro?: string
  items: DownloadProps[]
  useSVGIcons: boolean
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type DownloadProps = {
  key?: string
  title: string
  text?: string
  file_url: Url
}

export type DownloadBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  intro_classname: string
  content_classname: string
  list_classname: string
  item_classname: string
  link_classname: string
  link_label_classname: string
  link_text_classname: string
  link_icon_classname: string
  icon_file_id: string
  icon_pdf_id: string
  icon_word_id: string
  icon_excel_id: string
  icon_zip_id: string
}>

export function DownloadBlock<customBlockData, extra_images>(
  props: DownloadBlockProps,
  options?: { style?: DownloadBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, never>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (s: CMSState<customBlockData, extra_images, never>) =>
    mk_widget({
      run: _ => (
        <InView
          as="section"
          onChange={(inView) => blockInviewHandler('download', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
          triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
          threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
          id={`io-${options && options.key ? options.key : props.index}`}
          className={getClassName(options, "block_classname", "container")}
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className={getClassName(options, "inner_classname", "py-5")}>

            {(props.title || props.intro) && (
              <header className={getClassName(options, "header_classname", "")}>
                {props.title && <h2 className={getClassName(options, "title_classname", "mb-3")}>{props.title}</h2>}
                {props.intro && <p className={getClassName(options, "intro_classname", "")}>{props.intro}</p>}
              </header>
            )}

            <div className={getClassName(options, "content_classname", "")}>
              <ul className={getClassName(options, "list_classname", "list-unstyled row mb-0")}>
                {props.items.map((link, index) => (
                  // TODO: Add calender icon when file is a ics file
                  <li className={getClassName(options, "item_classname", "col-md-6")} key={`download-${options && options.key ? options.key : props.index}-${index}`}>
                    <a
                      download={true}
                      target="_blank"
                      href={link.file_url}
                      className={getClassName(options, "link_classname", "btn btn-link w-100 text-left border-bottom rounded-0 pl-0") + (link.file_url.endsWith('.ics') ? ' block__link--calendar' : ' block__link--download')}
                      onClick={() => window.dataLayer.push({
                        event: "event.refresco", category: "Downloads", action: link.title, label: window.location.pathname
                      })}
                    > 
                      <span className={getClassName(options, "link_label_classname", "d-block")}>{link.title}</span>
                      {link.text && (<p className={getClassName(options, "link_text_classname", "small m-0")}>{link.text}</p>)}
                      {props.useSVGIcons && (
                        <svg className={getClassName(options, "link_icon_classname", "")} aria-hidden="true">
                          <use xlinkHref={
                            getFileType(link.file_url).includes('pdf')
                              ? getClassName(options, "icon_pdf_id", "#icon--file")
                              : getFileType(link.file_url).includes('doc')
                                ? getClassName(options, "icon_word_id", "#icon--file")
                                : getFileType(link.file_url).includes('xls')
                                  ? getClassName(options, "icon_excel_id", "#icon--file")
                                    : getFileType(link.file_url).includes('zip') || getFileType(link.file_url).includes('rar')
                                      ? getClassName(options, "icon_zip_id", "#icon--file")
                                        : getClassName(options, "icon_file_id", "#icon--file")
                          }/>
                        </svg>
                      )}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </InView>
      ),
    })
}
